var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChefT(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      fill: "white"
    },
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "50 -200 500 900",
    height: 625,
    width: 625,
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath16",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "M 0,500 500,500 500,0 0,0 0,500 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25,0,0,-1.25,0,625)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath16)",
    id: "g14"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(425.1846,385.9526)",
    id: "g20"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    id: "path22",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 0.265,35.02 48.013,78.883 4.716,9.682 0.687,21.351 -8.997,26.063 -9.681,4.713 -21.347,0.686 -26.06,-8.995 l -46.146,-95.995 32.842,0 L 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(361.2471,296.5659)",
    id: "g24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    id: "path26",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 32.235,74.159 59.809,0 L 57.896,0 0,0 Z m 67.57,0 35.378,81.389 -3.621,0 -3.954,0 -59.995,0 -7.575,0 L -9.674,0 l -345.437,0 0,-8.449 484.445,0 0,8.449 -61.764,0 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(89.7793,251.7021)",
    id: "g28"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    id: "path30",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 0,-18.908 c -9.227,7.718 -18.771,11.578 -28.635,11.578 -10.871,0 -20.027,-3.905 -27.471,-11.715 -7.491,-7.765 -11.235,-17.264 -11.235,-28.498 0,-11.099 3.744,-20.462 11.235,-28.088 7.489,-7.627 16.668,-11.44 27.539,-11.44 5.618,0 10.39,0.912 14.318,2.74 2.192,0.912 4.463,2.145 6.817,3.699 2.351,1.553 4.829,3.426 7.432,5.618 l 0,-19.251 c -9.134,-5.161 -18.725,-7.741 -28.772,-7.741 -15.118,0 -28.019,5.276 -38.706,15.825 -10.642,10.641 -15.962,23.475 -15.962,38.5 0,13.473 4.453,25.485 13.359,36.035 C -59.12,1.278 -44.939,7.741 -27.539,7.741 -18.04,7.741 -8.86,5.16 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(147.9912,216.0107)",
    id: "g32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    id: "path34",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 45.625,0 0,41.377 15.962,0 0,-105.773 -15.962,0 0,49.393 -45.625,0 0,-49.393 -15.962,0 0,105.773 L 0,41.377 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(307.3223,242.3848)",
    id: "g36"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    id: "path38",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 -42.405,0 0,-25.415 41.173,0 0,-15.003 -41.173,0 0,-35.35 42.405,0 0,-15.002 -58.367,0 0,105.773 L 0,15.003 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(396.8428,242.3848)",
    id: "g40"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    id: "path42",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 -36.855,0 0,-25.415 35.553,0 0,-15.003 -35.553,0 0,-50.352 -15.962,0 0,105.773 L 0,15.003 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(487.4648,241.6318)",
    id: "g44"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    id: "path46",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 -12.948,-7.673 c -2.421,4.2 -4.727,6.941 -6.919,8.221 -2.284,1.46 -5.23,2.192 -8.837,2.192 -4.432,0 -8.108,-1.257 -11.029,-3.768 -2.924,-2.466 -4.385,-5.573 -4.385,-9.317 0,-5.161 3.837,-9.316 11.509,-12.467 l 10.549,-4.317 c 8.585,-3.472 14.867,-7.707 18.84,-12.708 3.973,-5.001 5.96,-11.132 5.96,-18.393 0,-9.728 -3.243,-17.767 -9.728,-24.115 -6.532,-6.394 -14.638,-9.591 -24.32,-9.591 -9.179,0 -16.761,2.717 -22.744,8.153 -5.89,5.433 -9.568,13.085 -11.029,22.95 l 16.168,3.562 c 0.729,-6.212 2.008,-10.505 3.836,-12.879 3.288,-4.569 8.084,-6.851 14.387,-6.851 4.977,0 9.111,1.666 12.399,5.001 3.288,3.333 4.933,7.558 4.933,12.674 0,2.055 -0.287,3.938 -0.858,5.65 -0.571,1.713 -1.462,3.289 -2.67,4.728 -1.212,1.438 -2.775,2.785 -4.693,4.042 -1.919,1.256 -4.203,2.454 -6.851,3.596 l -10.208,4.248 c -14.477,6.119 -21.716,15.072 -21.716,26.854 0,7.947 3.036,14.592 9.112,19.936 6.073,5.388 13.632,8.084 22.675,8.084 C -16.373,17.812 -6.851,11.873 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.1836,6.1816)",
    id: "g48"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    id: "path50",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 0,91.729 -27.608,0 0,8.564 64.396,0 0,-8.564 -27.677,0 L 9.111,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(127.1636,48.0391)",
    id: "g52"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    id: "path54",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 34.871,0 17.747,43.592 0,0 Z m -25.643,-41.857 44.05,104.266 42.201,-104.266 -9.977,0 -12.792,33.979 -40.952,0 -13.285,-33.979 -9.245,0 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(245.0107,14.0596)",
    id: "g56"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    id: "path58",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 11.646,0 c 10.229,0 16.92,1.21 20.072,3.631 4.704,3.607 7.056,8.974 7.056,16.099 0,8.448 -2.671,14.249 -8.015,17.401 -3.152,1.871 -8.861,2.808 -17.126,2.808 L 0,39.939 0,0 Z m 0,47.817 11.394,0 c 7.55,0 13.043,1.075 16.474,3.227 4.301,2.743 6.453,7.617 6.453,14.618 0,7.412 -2.037,12.537 -6.108,15.374 -3.342,2.334 -8.948,3.501 -16.819,3.501 L 0,84.537 0,47.817 Z m -9.111,-55.695 0,100.293 17.4,0 c 6.073,0 10.413,-0.16 13.016,-0.479 5.115,-0.686 9.157,-2.148 12.126,-4.385 6.803,-5.116 10.207,-12.195 10.207,-21.237 0,-5.253 -1.348,-9.728 -4.041,-13.427 C 36.81,49.051 32.928,46.516 27.95,45.283 34.39,44.324 39.436,41.754 43.09,37.577 46.742,33.396 48.57,28.064 48.57,21.58 48.57,12.216 45.715,4.886 40.007,-0.41 36.308,-3.836 31.329,-6.052 25.073,-7.056 21.83,-7.604 16.281,-7.878 8.426,-7.878 l -17.537,0 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(345.2803,6.1816)",
    id: "g60"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    id: "path62",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 0,100.293 9.11,0 0,-91.73 34.391,0 L 43.501,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(440.1309,6.1816)",
    id: "g64"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    id: "path66",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 0,100.293 49.666,0 0,-8.564 -40.556,0 0,-31.375 40.556,0 0,-8.563 -40.556,0 0,-43.228 40.556,0 L 49.666,0 0,0 Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChefT);
export default __webpack_public_path__ + "static/media/chef-t.2db6321745c1f49fe9856a3734e43ad6.svg";
export { ForwardRef as ReactComponent };